<template>

    <div class="h-screen-70 flex">

        <div class="text-gray-800 text-2xl m-auto text-center">
            404 | Not Found
        </div>

    </div>

</template>

<script>

export default {
    name: 'NotFound',
}

</script>